import { AxiosResponse } from 'axios';
import { api } from './base/api';
import {
  PartDetailBySupplierInventoryResponse,
  PartSearchResponse,
  XnuupPartIdAutoCompleteResponse
} from '../models/response';
import { IPartApi } from './base';
import {
  PartSearchRequest,
  XnuupPartIdAutocompleteFilterRequest
} from '../models/request';
import { PaginationResponse } from '../models/common/paginationResponse';
import { Result } from '../models/common/resultResponse';
import { TimeoutRequestConfigurationEnum } from '../services/enum/TimeoutRequestConfigurationEnum';

const baseRoute: string = 'Part';

export class PartApi extends IPartApi {
  private activeAbortController: AbortController | null = null;

  async getSearchParts(
    request: PartSearchRequest
  ): Promise<AxiosResponse<PaginationResponse<PartSearchResponse>>> {
    if (this.activeAbortController) {
      this.activeAbortController.abort();
    }
    this.activeAbortController = new AbortController();
    const response = await api.post(`${baseRoute}`, request, {
      signal: this.activeAbortController.signal,
      timeout: TimeoutRequestConfigurationEnum.OneMinuteInMilliseconds
    });
    this.activeAbortController = null;
    return response;
  }

  getPartDetailBySupplierInventory(request: {
    guid?: string;
    guidQuoteSupplierItem?: string;
  }): Promise<AxiosResponse<Result<PartDetailBySupplierInventoryResponse>>> {
    return api.get(`${baseRoute}/detailbysupplierinventory`, {
      params: request
    });
  }

  async getXnuupPartId(
    request: XnuupPartIdAutocompleteFilterRequest
  ): Promise<
    AxiosResponse<PaginationResponse<XnuupPartIdAutoCompleteResponse>>
  > {
    if (this.activeAbortController) this.activeAbortController.abort();
    this.activeAbortController = new AbortController();

    const response = await api.post(`${baseRoute}/getXnuupParts`, request, {
      signal: this.activeAbortController.signal
    });
    this.activeAbortController = null;
    return response;
  }
}
